// extracted by mini-css-extract-plugin
export default {"header":"header_header__yxVQF","logo":"header_logo__RKlP1"};